export default __webpack_public_path__ + "static/media/qr_chplay_okara.a04431f5.svg";